// extracted by mini-css-extract-plugin
export default {"sidebar":"skeleton-styles-module__sidebar___NhfdC","dealcard":"skeleton-styles-module__dealcard___5igWP","animation":"skeleton-styles-module__animation___jXvJM"};